module.exports = __webpack_public_path__ + "static/media/direction-right.30e220f2.svg";